import { AbstractControl, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { timer } from 'rxjs';

export default class FormControlHelper {
    static resetValidation(control: AbstractControl): void {
        control.clearValidators();
        control.markAsPristine();
        control.markAsUntouched();
        control.updateValueAndValidity();
    }

    static setValidation(control: AbstractControl, validatorFn): void {
        control.setValidators(validatorFn);
        control.updateValueAndValidity();
        control.markAsDirty();
        control.markAsTouched();
    }

    static setRequired(control: AbstractControl): void {
        control.setValidators(Validators.required);
        control.updateValueAndValidity();
        control.markAsDirty();
        control.markAsTouched();
    }

    static validateAllFields(formGroup: FormGroup): void {
        this.actionValidateAllFields(formGroup);
        this.focusFirstFieldInvalid();
    }

    static actionValidateAllFields(formGroup: FormGroup): void {
        Object.keys(formGroup.controls).forEach((field) => {
            this.actionValidateControl(formGroup.get(field));
        });
    }

    static actionValidateControl(control: AbstractControl): void {
        if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
            control.markAsDirty({ onlySelf: true });
        } else if (control instanceof FormGroup) {
            this.validateAllFields(control);
        } else if (control instanceof FormArray) {
            control.controls.forEach((it) => this.actionValidateControl(it));
        }
    }

    static focusFirstFieldInvalid(): void {
        timer(150).subscribe(() => {
            // tslint:disable-next-line: max-line-length
            const elementFirst: HTMLElement = document.querySelector(
                '[formControlName].ng-invalid.ng-touched,[formControlName] .ng-invalid.ng-touched input, .form-group .ng-invalid.ng-touched,.form-group  .ng-invalid.ng-touched input,mat-form-field.ng-invalid.ng-touched input'
            ) as HTMLElement;
            if (elementFirst) {
                elementFirst.focus();
                elementFirst.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    static clearValidators(formGroup: FormGroup): void {
        Object.keys(formGroup.controls).forEach((field) => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                this.resetValidation(control);
            } else if (control instanceof FormGroup) {
                this.clearValidators(control);
            }
        });
    }

    static validateControls(controls: AbstractControl[]): boolean {
        let isValid = true;
        if (controls) {
            for (let i = 0; i < controls.length; i++) {
                const control = controls[i];
                if (control.invalid) {
                    isValid = false;
                    control.markAsDirty();
                    control.markAsTouched();
                }
            }
        }
        return isValid;
    }

    static unTouchedControls(control: AbstractControl): void {
        if (control instanceof FormGroup) {
            Object.keys(control.controls).forEach((field) => {
                const ctrl = control.get(field);
                if (ctrl instanceof FormControl) {
                    ctrl.markAsPristine();
                    ctrl.markAsUntouched();
                } else if (ctrl instanceof FormGroup) {
                    this.unTouchedControls(ctrl);
                }
            });
        } else if (control instanceof FormArray) {
            Object.keys(control.controls).forEach((field) => {
                const ctrl = control.get(field);
                if (ctrl instanceof FormControl) {
                    ctrl.markAsPristine();
                    ctrl.markAsUntouched();
                } else if (ctrl instanceof FormGroup) {
                    this.unTouchedControls(ctrl);
                }
            });
        }
    }
}
